import { getPlugTypeName } from './plugtype-utils';

export enum EpdIcon {
  Refresh = 'refresh.svg',
  MapPin = 'map-pin.svg',
  PlugCcsType1 = 'plugs/ccs-type-1.svg',
  PlugCcsType2 = 'plugs/ccs-type-2.svg',
  PlugCee = 'plugs/cee.svg',
  PlugChademo = 'plugs/chademo.svg',
  PlugGbt = 'plugs/gbt.svg',
  PlugPowerlock = 'plugs/powerlock.svg',
  PlugType1 = 'plugs/type-1.svg',
  PlugType2 = 'plugs/type-2.svg',
  PlugType3 = 'plugs/type-3.svg',
  PlugUnknown = 'plugs/unknown.svg',
}

export const epdIconToUrl = (icon: EpdIcon): string => {
  return `/assets/img/icons/generic/${icon}`;
};

const plugIconsByName: Record<string, EpdIcon> = {
  'ccs-type-1': EpdIcon.PlugCcsType1,
  'ccs-type-2': EpdIcon.PlugCcsType2,
  'type-1': EpdIcon.PlugType1,
  'type-2': EpdIcon.PlugType2,
  'type-3': EpdIcon.PlugType3,
  cee: EpdIcon.PlugCee,
  chademo: EpdIcon.PlugChademo,
  gbt: EpdIcon.PlugGbt,
  powerlock: EpdIcon.PlugPowerlock,
};

export const getPlugIcon = (plugType: string): EpdIcon => {
  const plugTypeName = getPlugTypeName(plugType);
  return plugIconsByName[plugTypeName] ?? EpdIcon.PlugUnknown;
};

export enum EpdBrandedIcon {
  MasterCardLogo = 'mastercard-logo.svg',
  PaypalLogo = 'paypal-logo.svg',
}

export const epdBrandedIconToUrl = (icon: EpdBrandedIcon): string => {
  return `/assets/img/icons/branding/${icon}`;
};
